import { Link } from 'react-router';

import { buildAnvaLink } from '@/lib/party';
import cn from '@/lib/utils/cn';

import CopyButton from './CopyButton';

type Props = {
  crm: string;
  ref: string;
};

const AnvaLink = ({ ref }: { ref: string }) => {
  return (
    <span className="flex gap-0.5">
      <Link to={buildAnvaLink(ref)} target="_blank" className="hover:underline">
        {ref}
      </Link>
      <CopyButton text={ref} />
    </span>
  );
};

const Copy = ({ ref, isTruncated }: { ref: string; isTruncated: boolean }) => {
  return (
    <span className="flex items-center gap-0.5">
      <span className={cn(isTruncated && 'max-w-20 truncate')} title={ref}>
        {ref}
      </span>
      <CopyButton text={ref} />
    </span>
  );
};

export default function CrmLink({ crm, ref }: Props) {
  const isBrio = crm?.toLowerCase() === 'brio';

  return (
    <div className="flex items-center">
      <span className="font-bold">{crm?.toUpperCase()}:&nbsp;</span>
      {crm === 'anva' && <AnvaLink ref={ref} />}
      {crm !== 'anva' && <Copy ref={ref} isTruncated={isBrio} />}
    </div>
  );
}
